import Service, { service } from '@ember/service';

export default class CannyService extends Service {
  @service('browser/window') window;
  @service tagManager;

  isInitializing = false;

  identify() {
    this.track({ event: 'Canny Identify' });
  }

  track(data) {
    if (!this.hasInitialized) {
      this.initialize();
    }
    this.tagManager.push(data);
  }

  initialize() {
    if (this.isInitializing || this.hasInitialized) {
      return;
    }
    this.isInitializing = true;
    this.track({ event: 'Canny Initialize' });
    this.isInitializing = false;
  }

  get hasInitialized() {
    return !!this.window.Canny;
  }
}
